import { Dialog } from "@/components/ui/Dialog";
import { DevRoleSwitcherPanel } from "@/components/DevRoleSwitcherPanel";

export interface DevRoleSwitchModalProps {
  open: boolean;
  onClose: () => void;
}

export function DevRoleSwitchModal({ open, onClose }: DevRoleSwitchModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title="Dev: Rolle simulieren"
      description="Wähle eine oder mehrere Gruppen für die Simulation. Deine echten Entra-Zuweisungen bleiben unverändert."
      size="lg"
      zIndexClass="z-[200]"
      bodyClassName="!py-3"
    >
      <DevRoleSwitcherPanel onApplied={onClose} />
    </Dialog>
  );
}
